import React, { createRef, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Button,
  Divider,
  Form,
  Grid,
  Icon,
  Label,
  Segment,
  TextArea,
} from "semantic-ui-react";
import Swal from "sweetalert2";
import { useForm } from "../../hooks/useForm";
import { cargarParticipante, enviarPrecalificacion } from "../../utils/Datos";
import { SeleccionarNota } from "../Otros/SeleccionarNota";
import Tooltip from "../Otros/Tooltip";

export const EvaluarFuncionario = ({ id_participant }) => {
  const [searchParams] = useSearchParams();
  const id_preQualifications = searchParams.get("id_preQualifications");
  const [id_prequalifiers, setId_prequalifiers] = useState(0);
  const [cargandoDatos, setCargandoDatos] = useState(false);
  const [segmento, setSegmento] = useState(1);
  const [declaracion, setDeclaracion] = useState(false);
  const scrollRef = createRef();
  const navigate = useNavigate();

  const [values, handleInputChange, reset, updateValue] = useForm({
    volumeOfWork: 0,
    speedInExecution: 0,
    opportunityInExecution: 0,
    planningWork: 0,
    abilityToExecute: 0,
    jobKnowledge: 0,
    studies: 0,
    serviceCapacity: 0,
    trainingVolunteer: 0,
    creativityToSolveProblems: 0,
    easyIntegration: 0,
    permanency: 0,
    punctuality: 0,
    standardsCompliance: 0,
    taskFulfillment: 0,
    preMeetingStatement: 0,
    comentario1A: "",
    comentario1B: "",
    comentario2A: "",
    comentario2B: "",
    comentario2C: "",
    comentario3A: "",
    comentario3B: "",
  });
  const {
    volumeOfWork,
    speedInExecution,
    opportunityInExecution,
    planningWork,
    abilityToExecute,
    jobKnowledge,
    studies,
    serviceCapacity,
    trainingVolunteer,
    creativityToSolveProblems,
    easyIntegration,
    permanency,
    punctuality,
    standardsCompliance,
    taskFulfillment,
    preMeetingStatement,
    comentario1A,
    comentario1B,
    comentario2A,
    comentario2B,
    comentario2C,
    comentario3A,
    comentario3B,
  } = values;
  const handleClick = () => {
    setCargandoDatos(true);
    const payload = {
      id_preQualifications: id_preQualifications,
      volumeOfWork: volumeOfWork,
      speedInExecution: speedInExecution,
      opportunityInExecution: opportunityInExecution,
      planningWork: planningWork,
      abilityToExecute: abilityToExecute,
      jobKnowledge: jobKnowledge,
      studies: studies,
      serviceCapacity: serviceCapacity,
      trainingVolunteer: trainingVolunteer,
      creativityToSolveProblems: creativityToSolveProblems,
      easyIntegration: easyIntegration,
      permanency: permanency,
      punctuality: punctuality,
      standardsCompliance: standardsCompliance,
      taskFulfillment: taskFulfillment,
      preMeetingStatement: declaracion,
      id_prequalifiers: id_prequalifiers,
      commentSF11: comentario1A,
      commentSF12: comentario1B,
      commentSF21: comentario2A,
      commentSF22: comentario2B,
      commentSF23: comentario2C,
      commentSF31: comentario3A,
      commentSF32: comentario3B,
    };

    if (
      [
        volumeOfWork,
        speedInExecution,
        opportunityInExecution,
        planningWork,
        abilityToExecute,
        jobKnowledge,
        studies,
        serviceCapacity,
        trainingVolunteer,
        creativityToSolveProblems,
        easyIntegration,
        permanency,
        punctuality,
        standardsCompliance,
        taskFulfillment,
      ].includes(0)
    ) {
      Swal.fire({
        title: "Error",
        text: "Debe completar todos los campos antes de continuar",
        icon: "error",
      });
      setCargandoDatos(false);
      return false;
    }
    if (
      [
        comentario1A,
        comentario1B,
        comentario2A,
        comentario2B,
        comentario2C,
        comentario3A,
        comentario3B,
      ].includes("")
    ) {
      Swal.fire({
        title: "Error",
        text: "Debe completar todos los comentarios antes de continuar",
        icon: "error",
      });
      setCargandoDatos(false);
      return false;
    }

    enviarPrecalificacion(payload).then((respuesta) => {
      if (respuesta.status === true) {
        Swal.fire({
          title: "Precalificación enviada",
          text: "Funcionario/a calificado/a",
          icon: "success",
          confirmButtonText: "Ok",
          didDestroy: () => {
            navigate("/precalificar");
          },
        });
      } else {
        Swal.fire({
          title: "Error",
          text: respuesta.errores ?? "No Calificado",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      setCargandoDatos(false);
    });
  };

  useEffect(() => {
    cargarParticipante(id_participant).then((participante) => {
      if (participante != null) {
        setId_prequalifiers(participante.id_prequalifiers);
      }
    });
  }, []);

  return (
    <div className="card-body" id="card-precalificacion" ref={scrollRef}>
      <Form>
        <div className="row">
          <div className="col-lg-8 col-sm-12">
            <Segment.Group style={{ display: segmento === 1 ? "" : "none" }}>
              <Segment padded>
                <Grid>
                  <Grid.Row>
                    <Grid.Column  style={{display: "flex", alignItems: "center" }}>
                      <h2>
                        <Label
                          circular
                          color="blue"
                          size="huge"
                          className="mr-4"
                        >
                          1
                        </Label>
                        &nbsp;&nbsp;FACTOR RENDIMIENTO
                        <Tooltip texto={`Rendimiento: medirá el trabajo ejecutado durante el período, en relación a las tareas encomendadas.`}><i className="ki-solid ki-question-2 fs-2x pointer text-muted ms-3"></i></Tooltip>
                      </h2>
                      
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column style={{display: "flex", alignItems: "center" }}>
                      <Label color="blue" ribbon>
                        <h3 className="text-white">
                          <Label circular color="teal" size="large">
                            A
                          </Label>{" "}
                          &nbsp;&nbsp;Cantidad de Trabajo
                        </h3>
                      </Label>
                      <Tooltip texto={`Cantidad de trabajo: mide el volumen de trabajo desarrollado y la rapidez y oportunidad de su ejecución.`}><i className="ki-solid ki-question-2 fs-2x pointer text-muted"></i></Tooltip>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={8} style={{ paddingLeft: "30px"}}>
                      Volumen de trabajo 
                    </Grid.Column>
                    <Grid.Column textAlign="right" width={8}>
                      <Form.Field>
                        <SeleccionarNota
                          nombre="volumeOfWork"
                          nuevoValue={volumeOfWork}
                          updateValue={updateValue}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Divider hidden />

                    <Grid.Column width={8} style={{ paddingLeft: "30px" }}>
                      Rapidez en la ejecución del trabajo
                    </Grid.Column>
                    <Grid.Column textAlign="right" width={8}>
                      <Form.Field>
                        <SeleccionarNota
                          nombre="speedInExecution"
                          nuevoValue={speedInExecution}
                          updateValue={updateValue}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Divider hidden />

                    <Grid.Column width={8} style={{ paddingLeft: "30px" }}>
                      Oportunidad en la ejecución del trabajo
                    </Grid.Column>
                    <Grid.Column textAlign="right" width={8}>
                      <Form.Field>
                        <SeleccionarNota
                          nombre="opportunityInExecution"
                          nuevoValue={opportunityInExecution}
                          updateValue={updateValue}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column
                      width={16}
                      className="mt-8"
                      style={{ paddingLeft: "30px" }}
                    >
                      <span>Comentarios</span>
                      <TextArea
                        placeHolder="Máximo 700 caracteres"
                        maxLength="700"
                        name="comentario1A"
                        onChange={handleInputChange}
                        className="mt-2"
                      />
                      <Label
                        className="float-end mt-1"
                        color={
                          comentario1A.length == 0
                            ? "olive"
                            : comentario1A.length > 700
                            ? "red"
                            : "green"
                        }
                        key={"labelComentario1A"}
                      >
                        {comentario1A.length}/700
                      </Label>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
              <Segment padded>
                <Grid>
                  <Grid.Row>
                    <Grid.Column style={{display: "flex", alignItems: "center" }}>
                      <Label color="blue" ribbon>
                        <h3 className="text-white">
                          <Label circular color="teal" size="large">
                            B
                          </Label>{" "}
                          &nbsp;&nbsp;Calidad de la Labor Realizada
                        </h3>
                      </Label>
                      <Tooltip texto={`Calidad de la labor realizada: evalúa las características de la labor cumplida. Mide la ausencia de errores en el trabajo y la habilidad en su ejecución.`}><i className="ki-solid ki-question-2 fs-2x pointer text-muted"></i></Tooltip>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={8} style={{ paddingLeft: "30px" }}>
                      Planificación del trabajo
                    </Grid.Column>
                    <Grid.Column textAlign="right" width={8}>
                      <Form.Field>
                        <SeleccionarNota
                          nombre="planningWork"
                          nuevoValue={planningWork}
                          updateValue={updateValue}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Divider hidden />

                    <Grid.Column width={8} style={{ paddingLeft: "30px" }}>
                      Habilidad en la ejecución del trabajo (ausencia de
                      errores)
                    </Grid.Column>
                    <Grid.Column textAlign="right" width={8}>
                      <Form.Field>
                        <SeleccionarNota
                          nombre="abilityToExecute"
                          nuevoValue={abilityToExecute}
                          updateValue={updateValue}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column
                      width={16}
                      className="mt-8"
                      style={{ paddingLeft: "30px" }}
                    >
                      <span>Comentarios</span>
                      <TextArea
                        placeHolder="Máximo 700 caracteres"
                        maxLength="700"
                        name="comentario1B"
                        onChange={handleInputChange}
                        className="mt-2"
                      />
                      <Label
                        className="float-end mt-1"
                        color={
                          comentario1B.length == 0
                            ? "olive"
                            : comentario1B.length > 700
                            ? "red"
                            : "green"
                        }
                        key={"labelComentario1B"}
                      >
                        {comentario1B.length}/700
                      </Label>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
            </Segment.Group>
            <Segment.Group style={{ display: segmento === 2 ? "" : "none" }}>
              <Segment padded>
                <Grid>
                  <Grid.Row>
                    <Grid.Column>
                      <h2>
                        <Label
                          circular
                          color="blue"
                          size="huge"
                          className="mr-4"
                        >
                          2
                        </Label>
                        &nbsp;&nbsp;FACTOR CONDICIONES PERSONALES
                        <Tooltip texto={`Condiciones personales: evalúa aquellas aptitudes del funcionario vinculadas directamente con el cumplimiento de sus funciones.`}><i className="ki-solid ki-question-2 fs-2x pointer text-muted ms-3"></i></Tooltip>
                      </h2>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column style={{display: "flex", alignItems: "center" }}>
                      <Label color="blue" ribbon>
                        <h3 className="text-white">
                          <Label circular color="teal" size="large">
                            C
                          </Label>{" "}
                          &nbsp;&nbsp;Conocimiento del Trabajo
                        </h3>
                      </Label>
                      <Tooltip texto={`Conocimiento del trabajo: mide el grado de conocimiento que la persona tiene de la actividad que realiza, los conocimientos teóricos, estudios y los cursos de formación o de especialización relacionados con las funciones del cargo.`}><i className="ki-solid ki-question-2 fs-2x pointer text-muted"></i></Tooltip>

                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={8} style={{ paddingLeft: "30px" }}>
                      Conocimiento del trabajo
                    </Grid.Column>
                    <Grid.Column textAlign="right" width={8}>
                      <Form.Field>
                        <SeleccionarNota
                          nombre="jobKnowledge"
                          nuevoValue={jobKnowledge}
                          updateValue={updateValue}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Divider hidden />

                    <Grid.Column width={8} style={{ paddingLeft: "30px" }}>
                      Estudios
                    </Grid.Column>
                    <Grid.Column textAlign="right" width={8}>
                      <Form.Field>
                        <SeleccionarNota
                          nombre="studies"
                          nuevoValue={studies}
                          updateValue={updateValue}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Divider hidden />

                    <Grid.Column width={8} style={{ paddingLeft: "30px" }}>
                      Capacidad de servicio relacionada con su función
                    </Grid.Column>
                    <Grid.Column textAlign="right" width={8}>
                      <Form.Field>
                        <SeleccionarNota
                          nombre="serviceCapacity"
                          nuevoValue={serviceCapacity}
                          updateValue={updateValue}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column
                      width={16}
                      className="mt-8"
                      style={{ paddingLeft: "30px" }}
                    >
                      <span>Comentarios</span>
                      <TextArea
                        placeHolder="Máximo 700 caracteres"
                        maxLength="700"
                        name="comentario2A"
                        onChange={handleInputChange}
                        className="mt-2"
                      />
                      <Label
                        className="float-end mt-1"
                        color={
                          comentario2A.length == 0
                            ? "olive"
                            : comentario2A.length > 700
                            ? "red"
                            : "green"
                        }
                        key={"labelComentario2A"}
                      >
                        {comentario2A.length}/700
                      </Label>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
              <Segment padded>
                <Grid>
                  <Grid.Row>
                    <Grid.Column style={{display: "flex", alignItems: "center" }}>
                      <Label color="blue" ribbon>
                        <h3 className="text-white">
                          <Label circular color="teal" size="large">
                            D
                          </Label>{" "}
                          &nbsp;&nbsp;Interés por el trabajo que realiza
                        </h3>
                      </Label>
                      <Tooltip texto={`Interés por el trabajo que realiza: mide el deseo del funcionario de perfeccionarse en el cumplimiento de sus obligaciones y la capacidad de obrar oportunamente, de proponer la realización de actividades y de soluciones ante los problemas que se presenten y de proponer objetivos o procedimientos nuevos para la mejor realización del trabajo asignado.`}><i className="ki-solid ki-question-2 fs-2x pointer text-muted"></i></Tooltip>

                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={8} style={{ paddingLeft: "30px" }}>
                      Capacitación voluntaria directamente relacionada con su
                      función
                    </Grid.Column>
                    <Grid.Column textAlign="right" width={8}>
                      <Form.Field>
                        <SeleccionarNota
                          nombre="trainingVolunteer"
                          nuevoValue={trainingVolunteer}
                          updateValue={updateValue}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Divider hidden />

                    <Grid.Column width={8} style={{ paddingLeft: "30px" }}>
                      Creatividad para solucionar problemas
                    </Grid.Column>
                    <Grid.Column textAlign="right" width={8}>
                      <Form.Field>
                        <SeleccionarNota
                          nombre="creativityToSolveProblems"
                          nuevoValue={creativityToSolveProblems}
                          updateValue={updateValue}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column
                      width={16}
                      className="mt-8"
                      style={{ paddingLeft: "30px" }}
                    >
                      <span>Comentarios</span>
                      <TextArea
                        placeHolder="Máximo 700 caracteres"
                        maxLength="700"
                        name="comentario2B"
                        onChange={handleInputChange}
                        className="mt-2"
                      />
                      <Label
                        className="float-end mt-1"
                        color={
                          comentario2B.length == 0
                            ? "olive"
                            : comentario2B.length > 700
                            ? "red"
                            : "green"
                        }
                        key={"labelComentario2B"}
                      >
                        {comentario2B.length}/700
                      </Label>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
              <Segment padded>
                <Grid>
                  <Grid.Row>
                    <Grid.Column style={{display: "flex", alignItems: "center" }}>
                      <Label color="blue" ribbon>
                        <h3 className="text-white">
                          <Label circular color="teal" size="large">
                            E
                          </Label>{" "}
                          &nbsp;&nbsp;Capacidad para realizar trabajos en grupo
                        </h3>
                      </Label>
                      <Tooltip texto={`Capacidad para realizar trabajos en grupo: mide la facilidad de integración del funcionario en equipos de trabajo, así como la colaboración eficaz que éste presta cuando se requiere que trabaje con grupos de personas.`}><i className="ki-solid ki-question-2 fs-2x pointer text-muted"></i></Tooltip>

                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={8} style={{ paddingLeft: "30px" }}>
                      Facilidad de integración al equipo de trabajo
                    </Grid.Column>
                    <Grid.Column textAlign="right" width={8}>
                      <Form.Field>
                        <SeleccionarNota
                          nombre="easyIntegration"
                          nuevoValue={easyIntegration}
                          updateValue={updateValue}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Divider hidden />
                    <Grid.Column
                      width={16}
                      className="mt-8"
                      style={{ paddingLeft: "30px" }}
                    >
                      <span>Comentarios</span>
                      <TextArea
                        placeHolder="Máximo 700 caracteres"
                        maxLength="700"
                        name="comentario2C"
                        onChange={handleInputChange}
                        className="mt-2"
                      />
                      <Label
                        className="float-end mt-1"
                        color={
                          comentario2C.length == 0
                            ? "olive"
                            : comentario2C.length > 700
                            ? "red"
                            : "green"
                        }
                        key={"labelComentario2C"}
                      >
                        {comentario2C.length}/700
                      </Label>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
            </Segment.Group>

            <Segment.Group style={{ display: segmento === 3 ? "" : "none" }}>
              <Segment padded>
                <Grid>
                  <Grid.Row>
                    <Grid.Column>
                      <h2>
                        <Label
                          circular
                          color="blue"
                          size="huge"
                          className="mr-4"
                        >
                          3
                        </Label>
                        &nbsp;&nbsp;FACTOR COMPORTAMIENTO FUNCIONARIO
                        <Tooltip texto={`Comportamiento funcionario: evalúa la conducta del funcionario en el cumplimiento de sus obligaciones.`}><i className="ki-solid ki-question-2 fs-2x pointer text-muted ms-3"></i></Tooltip>
                      </h2>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column style={{display: "flex", alignItems: "center" }}> 
                      <Label color="blue" ribbon>
                        <h3 className="text-white">
                          <Label circular color="teal" size="large">
                            F
                          </Label>{" "}
                          &nbsp;&nbsp;Asistencia y puntualidad
                        </h3>
                      </Label>
                      <Tooltip texto={`Asistencia y puntualidad: mide la presencia o ausencia del funcionario en el lugar de trabajo y la exactitud en el cumplimiento de la jornada laboral.`}><i className="ki-solid ki-question-2 fs-2x pointer text-muted ms-3"></i></Tooltip>

                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={8} style={{ paddingLeft: "30px" }}>
                      Permanencia
                    </Grid.Column>
                    <Grid.Column textAlign="right" width={8}>
                      <Form.Field>
                        <SeleccionarNota
                          nombre="permanency"
                          nuevoValue={permanency}
                          updateValue={updateValue}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Divider hidden />

                    <Grid.Column width={8} style={{ paddingLeft: "30px" }}>
                      Puntualidad
                    </Grid.Column>
                    <Grid.Column textAlign="right" width={8}>
                      <Form.Field>
                        <SeleccionarNota
                          nombre="punctuality"
                          nuevoValue={punctuality}
                          updateValue={updateValue}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Divider hidden />

                    <Grid.Column
                      width={16}
                      className="mt-8"
                      style={{ paddingLeft: "30px" }}
                    >
                      <span>Comentarios</span>
                      <TextArea
                        placeHolder="Máximo 700 caracteres"
                        maxLength="700"
                        name="comentario3A"
                        onChange={handleInputChange}
                        className="mt-2"
                      />
                      <Label
                        className="float-end mt-1"
                        color={
                          comentario3A.length == 0
                            ? "olive"
                            : comentario3A.length > 700
                            ? "red"
                            : "green"
                        }
                        key={"labelComentario3A"}
                      >
                        {comentario3A.length}/700
                      </Label>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
              <Segment padded>
                <Grid>
                  <Grid.Row>
                    <Grid.Column style={{display: "flex", alignItems: "center" }}>
                      <Label color="blue" ribbon>
                        <h3 className="text-white">
                          <Label circular color="teal" size="large">
                            G
                          </Label>{" "}
                          &nbsp;&nbsp;Cumplimiento de normas e instrucciones
                        </h3>
                      </Label>
                      <Tooltip texto={`Cumplimiento de normas e instrucciones: mide el adecuado y oportuno respeto a los reglamentos e instrucciones de la municipalidad, a los demás deberes estatutarios, al cumplimiento de las tareas propias del cargo, y de las órdenes y cometidos que le importan o encomienden sus superiores.`}><i className="ki-solid ki-question-2 fs-2x pointer text-muted ms-3"></i></Tooltip>

                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={8} style={{ paddingLeft: "30px" }}>
                      Cumplimiento de normas
                    </Grid.Column>
                    <Grid.Column textAlign="right" width={8}>
                      <Form.Field>
                        <SeleccionarNota
                          nombre="standardsCompliance"
                          nuevoValue={standardsCompliance}
                          updateValue={updateValue}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Divider hidden />

                    <Grid.Column width={8} style={{ paddingLeft: "30px" }}>
                      Cumplimiento de tareas
                    </Grid.Column>
                    <Grid.Column textAlign="right" width={8}>
                      <Form.Field>
                        <SeleccionarNota
                          nombre="taskFulfillment"
                          nuevoValue={taskFulfillment}
                          updateValue={updateValue}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column
                      width={16}
                      className="mt-8"
                      style={{ paddingLeft: "30px" }}
                    >
                      <span>Comentarios</span>
                      <TextArea
                        placeHolder="Máximo 700 caracteres"
                        maxLength="700"
                        name="comentario3B"
                        onChange={handleInputChange}
                        className="mt-2"
                      />
                      <Label
                        className="float-end mt-1"
                        color={
                          comentario3B.length == 0
                            ? "olive"
                            : comentario3B.length > 700
                            ? "red"
                            : "green"
                        }
                        key={"labelComentario3B"}
                      >
                        {comentario3B.length}/700
                      </Label>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
            </Segment.Group>

            <Grid stretched>
              <Grid.Row stretched>
                <Grid.Column width={8} textAlign="left">
                  <Button
                    style={{ display: segmento > 1 ? "" : "none" }}
                    color="red"
                    onClick={() => {
                      setSegmento(segmento - 1);
                      var element = document.getElementById(
                        "card-precalificacion"
                      );
                      var headerOffset = 100;
                      var elementPosition = element.getBoundingClientRect().top;
                      var offsetPosition =
                        elementPosition + window.pageYOffset - headerOffset;
                      window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth",
                      });
                    }}
                  >
                    Volver
                  </Button>
                </Grid.Column>
                <Grid.Column width={8} textAlign="right">
                  <Button
                    style={{ display: segmento < 3 ? "" : "none" }}
                    color="green"
                    onClick={() => {
                      setSegmento(segmento + 1);
                      var element = document.getElementById(
                        "card-precalificacion"
                      );
                      var headerOffset = 100;
                      var elementPosition = element.getBoundingClientRect().top;
                      var offsetPosition =
                        elementPosition + window.pageYOffset - headerOffset;
                      window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth",
                      });
                    }}
                  >
                    Continuar
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
          <div className="col-lg-4 col-sm-12">
            <div>
              <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-12 p-6">
                <span className="svg-icon svg-icon-2tx svg-icon-warning me-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <rect
                      opacity="0.3"
                      x={2}
                      y={2}
                      width={20}
                      height={20}
                      rx={10}
                      fill="currentColor"
                    />
                    <rect
                      x={11}
                      y={14}
                      width={7}
                      height={2}
                      rx={1}
                      transform="rotate(-90 11 14)"
                      fill="currentColor"
                    />
                    <rect
                      x={11}
                      y={17}
                      width={2}
                      height={2}
                      rx={1}
                      transform="rotate(-90 11 17)"
                      fill="currentColor"
                    />
                  </svg>
                </span>
                <div className="d-flex flex-stack flex-grow-1">
                  <div className="fw-bold">
                    <h4 className="text-gray-900 fw-bolder">Declaración</h4>
                    <div className="fs-6 text-gray-700">
                      {`Declaro que me reuniré presencial o virtualmente con el(la) Funcionario(a) para entregar retroalimentación y fundamentación de la evaluación`}
                    </div>
                    <div className="form-check form-check-custom  form-check-success form-check-solid mt-8 mb-8">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="acepto"
                        value={"Acepto"}
                        checked={declaracion}
                        onChange={() => setDeclaracion(!declaracion)}
                      />
                      <label className="form-check-label" htmlFor="acepto">
                        Confirmo la declaración
                      </label>
                    </div>

                    <Button
                      color="green"
                      disabled={!declaracion || cargandoDatos}
                      onClick={handleClick}
                    >
                      <Icon name="star" /> {/**/} Evaluar
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
};
